// extracted by mini-css-extract-plugin
export default {"white-background":"ListOfReferrals_white-background__pQL3V","list":"ListOfReferrals_list__mFvwK"};